import React from "react";
//import classnames from "classnames";

const projectPosition = (value, min, max) => (value - min) / (max - min) * 100;

const projectRange = (start, end, min, max) =>
  (end - start) / (max - min) * 100;

const GaugeRange = ({ range, status, min, max }) => {
  const [start, end] = range;
  const position = projectPosition(start, min, max);
  const width = projectRange(start, end, min, max);

  const gaugeRangeStyle = {
    left: `${position}%`,
    width: `${width}%`,
  };

  return (
    <div style={gaugeRangeStyle} className={`apl-gauge__range--${status}`} />
  );
};

const Gauge = ({ min, max, value, ranges, showMinMax }) => {
  const position = projectPosition(value, min, max);
  const valueStyle = { left: `${position}%` };
  let uniqueId = 0;

  return (
    <div className="apl-gauge">
      {showMinMax ? <div className="apl-gauge__min">{min}</div> : null}
      <div className="apl-gauge__value" style={valueStyle} />
      {showMinMax ? <div className="apl-gauge__max">{max}</div> : null}
      <div className="apl-gauge__ranges">
        {ranges.map(item => (
          <GaugeRange {...item} key={(uniqueId += 1)} min={min} max={max} />
        ))}
      </div>
    </div>
  );
};

export default Gauge;



// WEBPACK FOOTER //
// ./casper/sass/components/gauge/gauge.js